export const LANGUAGE_REDUCER_KEY = 'language';
